import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  flex: {
    borderTop: `0.1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.gray[7] : theme.colors.gray[4]
    }`,
  },
}));
